import { gql, useQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { ErrorComponent } from "@src/components";
import { DetailPageHeader } from "@src/components/headers/DetailPageHeader";
import LoadingComponent from "@src/components/LoadingComponent";
import { type GQLTrapAlarmAdminQuery, type GQLTrapAlarmAdminQueryVariables } from "@src/graphql.generated";

import EditForm from "./EditForm";

export const trapAlarmQuery = gql`
    query TrapAlarmAdmin($id: ID!) {
        trapAlarmAdmin(id: $id) {
            id
            name
            phone
            pin
        }
    }
`;

export const EditTrapAlarm = ({ id }: { id: string }) => {
    const { data, error, loading } = useQuery<GQLTrapAlarmAdminQuery, GQLTrapAlarmAdminQueryVariables>(trapAlarmQuery, { variables: { id } });

    if (error) {
        return <ErrorComponent />;
    }

    if (loading || !data) {
        return <LoadingComponent />;
    }
    return (
        <>
            <DetailPageHeader />
            <Grid container spacing={4}>
                <Grid size={6}>
                    <EditForm trapAlarmAdmin={data.trapAlarmAdmin} />
                </Grid>
            </Grid>
        </>
    );
};
